export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  logo: "nav-logo",
  linkHome: "nav-link-home",
  linkServices: "nav-link-services",
  linkProcess: "nav-link-process",
  linkCases: "nav-link-cases",
  linkAbout: "nav-link-about",
  linkFaq: "nav-link-faq",
  linkContact: "nav-link-contact",
  ctaBook: "nav-cta-book",
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  ctaBook: "hero-cta-book",
  ctaView: "hero-cta-view",
};

export const CONTACT = {
  form: "contact-form",
  name: "contact-input-name",
  business: "contact-input-business",
  email: "contact-input-email",
  phone: "contact-input-phone",
  service: "contact-input-service",
  budget: "contact-input-budget",
  message: "contact-input-message",
  submit: "contact-submit",
};

export const MODAL = {
  bookRoot: "book-call-modal",
  bookClose: "book-call-close",
  bookSubmit: "book-call-submit",
};
